import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { LanguagePreference } from '../interface';
import i18next from 'i18next';

const LANGUAGE_STORAGE_KEY = 'language-preferences-storage';

type State = {
  currentLanguagePreference: LanguagePreference;
};

type Actions = {
  setLanguagePreference: (languagePreference: LanguagePreference) => void;
};

const initialState: State = {
  currentLanguagePreference: LanguagePreference.LATVIAN,
};

export const useLanguagePreferencesStore = create<State & Actions>()(
  persist(
    (set) => ({
      ...initialState,
      setLanguagePreference: (languagePreference: LanguagePreference) =>
        set({ currentLanguagePreference: languagePreference }),
    }),
    {
      name: LANGUAGE_STORAGE_KEY,
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

useLanguagePreferencesStore.subscribe(
  (
    { currentLanguagePreference },
    { currentLanguagePreference: prevLanguagePreference }
  ) => {
    if (currentLanguagePreference !== prevLanguagePreference) {
      i18next.changeLanguage(currentLanguagePreference);
    }
  }
);
